/**
 * 全球国家列表（United Kingdom 使用 UK，与业务库一致）
 */
export const WORLD_COUNTRIES = [
  {
    "code": "AF",
    "name": "Afghanistan",
    "nameZh": "阿富汗",
    "currencySymbol": "AFN"
  },
  {
    "code": "AL",
    "name": "Albania",
    "nameZh": "阿尔巴尼亚",
    "currencySymbol": "L"
  },
  {
    "code": "DZ",
    "name": "Algeria",
    "nameZh": "阿尔及利亚",
    "currencySymbol": "DZD"
  },
  {
    "code": "AD",
    "name": "Andorra",
    "nameZh": "安道尔",
    "currencySymbol": "€"
  },
  {
    "code": "AO",
    "name": "Angola",
    "nameZh": "安哥拉",
    "currencySymbol": "Kz"
  },
  {
    "code": "AG",
    "name": "Antigua and Barbuda",
    "nameZh": "安提瓜和巴布达",
    "currencySymbol": "$"
  },
  {
    "code": "AR",
    "name": "Argentina",
    "nameZh": "阿根廷",
    "currencySymbol": "$"
  },
  {
    "code": "AM",
    "name": "Armenia",
    "nameZh": "亚美尼亚",
    "currencySymbol": "AMD"
  },
  {
    "code": "AU",
    "name": "Australia",
    "nameZh": "澳大利亚",
    "currencySymbol": "A$"
  },
  {
    "code": "AT",
    "name": "Austria",
    "nameZh": "奥地利",
    "currencySymbol": "€"
  },
  {
    "code": "AZ",
    "name": "Azerbaijan",
    "nameZh": "阿塞拜疆",
    "currencySymbol": "₼"
  },
  {
    "code": "BS",
    "name": "Bahamas",
    "nameZh": "巴哈马",
    "currencySymbol": "$"
  },
  {
    "code": "BH",
    "name": "Bahrain",
    "nameZh": "巴林",
    "currencySymbol": "BD"
  },
  {
    "code": "BD",
    "name": "Bangladesh",
    "nameZh": "孟加拉国",
    "currencySymbol": "৳"
  },
  {
    "code": "BB",
    "name": "Barbados",
    "nameZh": "巴巴多斯",
    "currencySymbol": "$"
  },
  {
    "code": "BY",
    "name": "Belarus",
    "nameZh": "白俄罗斯",
    "currencySymbol": "Br"
  },
  {
    "code": "BE",
    "name": "Belgium",
    "nameZh": "比利时",
    "currencySymbol": "€"
  },
  {
    "code": "BZ",
    "name": "Belize",
    "nameZh": "伯利兹",
    "currencySymbol": "BZ$"
  },
  {
    "code": "BJ",
    "name": "Benin",
    "nameZh": "贝宁",
    "currencySymbol": "CFA"
  },
  {
    "code": "BT",
    "name": "Bhutan",
    "nameZh": "不丹",
    "currencySymbol": "Nu"
  },
  {
    "code": "BO",
    "name": "Bolivia",
    "nameZh": "玻利维亚",
    "currencySymbol": "Bs"
  },
  {
    "code": "BA",
    "name": "Bosnia and Herzegovina",
    "nameZh": "波黑",
    "currencySymbol": "KM"
  },
  {
    "code": "BW",
    "name": "Botswana",
    "nameZh": "博茨瓦纳",
    "currencySymbol": "P"
  },
  {
    "code": "BR",
    "name": "Brazil",
    "nameZh": "巴西",
    "currencySymbol": "R$"
  },
  {
    "code": "BN",
    "name": "Brunei",
    "nameZh": "文莱",
    "currencySymbol": "$"
  },
  {
    "code": "BG",
    "name": "Bulgaria",
    "nameZh": "保加利亚",
    "currencySymbol": "лв"
  },
  {
    "code": "BF",
    "name": "Burkina Faso",
    "nameZh": "布基纳法索",
    "currencySymbol": "CFA"
  },
  {
    "code": "BI",
    "name": "Burundi",
    "nameZh": "布隆迪",
    "currencySymbol": "FBu"
  },
  {
    "code": "CV",
    "name": "Cabo Verde",
    "nameZh": "佛得角",
    "currencySymbol": "$"
  },
  {
    "code": "KH",
    "name": "Cambodia",
    "nameZh": "柬埔寨",
    "currencySymbol": "៛"
  },
  {
    "code": "CM",
    "name": "Cameroon",
    "nameZh": "喀麦隆",
    "currencySymbol": "CFA"
  },
  {
    "code": "CA",
    "name": "Canada",
    "nameZh": "加拿大",
    "currencySymbol": "C$"
  },
  {
    "code": "CF",
    "name": "Central African Republic",
    "nameZh": "中非",
    "currencySymbol": "CFA"
  },
  {
    "code": "TD",
    "name": "Chad",
    "nameZh": "乍得",
    "currencySymbol": "CFA"
  },
  {
    "code": "CL",
    "name": "Chile",
    "nameZh": "智利",
    "currencySymbol": "$"
  },
  {
    "code": "CN",
    "name": "China",
    "nameZh": "中国",
    "currencySymbol": "¥"
  },
  {
    "code": "CO",
    "name": "Colombia",
    "nameZh": "哥伦比亚",
    "currencySymbol": "$"
  },
  {
    "code": "KM",
    "name": "Comoros",
    "nameZh": "科摩罗",
    "currencySymbol": "CF"
  },
  {
    "code": "CG",
    "name": "Congo",
    "nameZh": "刚果（布）",
    "currencySymbol": "CFA"
  },
  {
    "code": "CD",
    "name": "Congo (DRC)",
    "nameZh": "刚果（金）",
    "currencySymbol": "FC"
  },
  {
    "code": "CR",
    "name": "Costa Rica",
    "nameZh": "哥斯达黎加",
    "currencySymbol": "₡"
  },
  {
    "code": "CI",
    "name": "Cote d Ivoire",
    "nameZh": "科特迪瓦",
    "currencySymbol": "CFA"
  },
  {
    "code": "HR",
    "name": "Croatia",
    "nameZh": "克罗地亚",
    "currencySymbol": "€"
  },
  {
    "code": "CU",
    "name": "Cuba",
    "nameZh": "古巴",
    "currencySymbol": "$"
  },
  {
    "code": "CY",
    "name": "Cyprus",
    "nameZh": "塞浦路斯",
    "currencySymbol": "€"
  },
  {
    "code": "CZ",
    "name": "Czechia",
    "nameZh": "捷克",
    "currencySymbol": "Kč"
  },
  {
    "code": "DK",
    "name": "Denmark",
    "nameZh": "丹麦",
    "currencySymbol": "kr"
  },
  {
    "code": "DJ",
    "name": "Djibouti",
    "nameZh": "吉布提",
    "currencySymbol": "Fdj"
  },
  {
    "code": "DM",
    "name": "Dominica",
    "nameZh": "多米尼克",
    "currencySymbol": "$"
  },
  {
    "code": "DO",
    "name": "Dominican Republic",
    "nameZh": "多米尼加",
    "currencySymbol": "RD$"
  },
  {
    "code": "EC",
    "name": "Ecuador",
    "nameZh": "厄瓜多尔",
    "currencySymbol": "$"
  },
  {
    "code": "EG",
    "name": "Egypt",
    "nameZh": "埃及",
    "currencySymbol": "E£"
  },
  {
    "code": "SV",
    "name": "El Salvador",
    "nameZh": "萨尔瓦多",
    "currencySymbol": "$"
  },
  {
    "code": "GQ",
    "name": "Equatorial Guinea",
    "nameZh": "赤道几内亚",
    "currencySymbol": "CFA"
  },
  {
    "code": "ER",
    "name": "Eritrea",
    "nameZh": "厄立特里亚",
    "currencySymbol": "Nfk"
  },
  {
    "code": "EE",
    "name": "Estonia",
    "nameZh": "爱沙尼亚",
    "currencySymbol": "€"
  },
  {
    "code": "SZ",
    "name": "Eswatini",
    "nameZh": "斯威士兰",
    "currencySymbol": "E"
  },
  {
    "code": "ET",
    "name": "Ethiopia",
    "nameZh": "埃塞俄比亚",
    "currencySymbol": "Br"
  },
  {
    "code": "EU",
    "name": "European Union",
    "nameZh": "欧盟",
    "currencySymbol": "€"
  },
  {
    "code": "FJ",
    "name": "Fiji",
    "nameZh": "斐济",
    "currencySymbol": "FJ$"
  },
  {
    "code": "FI",
    "name": "Finland",
    "nameZh": "芬兰",
    "currencySymbol": "€"
  },
  {
    "code": "FR",
    "name": "France",
    "nameZh": "法国",
    "currencySymbol": "€"
  },
  {
    "code": "GA",
    "name": "Gabon",
    "nameZh": "加蓬",
    "currencySymbol": "CFA"
  },
  {
    "code": "GM",
    "name": "Gambia",
    "nameZh": "冈比亚",
    "currencySymbol": "D"
  },
  {
    "code": "GE",
    "name": "Georgia",
    "nameZh": "格鲁吉亚",
    "currencySymbol": "₾"
  },
  {
    "code": "DE",
    "name": "Germany",
    "nameZh": "德国",
    "currencySymbol": "€"
  },
  {
    "code": "GH",
    "name": "Ghana",
    "nameZh": "加纳",
    "currencySymbol": "GH₵"
  },
  {
    "code": "GR",
    "name": "Greece",
    "nameZh": "希腊",
    "currencySymbol": "€"
  },
  {
    "code": "GD",
    "name": "Grenada",
    "nameZh": "格林纳达",
    "currencySymbol": "$"
  },
  {
    "code": "GT",
    "name": "Guatemala",
    "nameZh": "危地马拉",
    "currencySymbol": "Q"
  },
  {
    "code": "GN",
    "name": "Guinea",
    "nameZh": "几内亚",
    "currencySymbol": "FG"
  },
  {
    "code": "GW",
    "name": "Guinea-Bissau",
    "nameZh": "几内亚比绍",
    "currencySymbol": "CFA"
  },
  {
    "code": "GY",
    "name": "Guyana",
    "nameZh": "圭亚那",
    "currencySymbol": "$"
  },
  {
    "code": "HT",
    "name": "Haiti",
    "nameZh": "海地",
    "currencySymbol": "G"
  },
  {
    "code": "HN",
    "name": "Honduras",
    "nameZh": "洪都拉斯",
    "currencySymbol": "L"
  },
  {
    "code": "HK",
    "name": "Hong Kong",
    "nameZh": "中国香港",
    "currencySymbol": "HK$"
  },
  {
    "code": "HU",
    "name": "Hungary",
    "nameZh": "匈牙利",
    "currencySymbol": "Ft"
  },
  {
    "code": "IS",
    "name": "Iceland",
    "nameZh": "冰岛",
    "currencySymbol": "kr"
  },
  {
    "code": "IN",
    "name": "India",
    "nameZh": "印度",
    "currencySymbol": "₹"
  },
  {
    "code": "ID",
    "name": "Indonesia",
    "nameZh": "印度尼西亚",
    "currencySymbol": "Rp"
  },
  {
    "code": "IR",
    "name": "Iran",
    "nameZh": "伊朗",
    "currencySymbol": "﷼"
  },
  {
    "code": "IQ",
    "name": "Iraq",
    "nameZh": "伊拉克",
    "currencySymbol": "ع.د"
  },
  {
    "code": "IE",
    "name": "Ireland",
    "nameZh": "爱尔兰",
    "currencySymbol": "€"
  },
  {
    "code": "IL",
    "name": "Israel",
    "nameZh": "以色列",
    "currencySymbol": "₪"
  },
  {
    "code": "IT",
    "name": "Italy",
    "nameZh": "意大利",
    "currencySymbol": "€"
  },
  {
    "code": "JM",
    "name": "Jamaica",
    "nameZh": "牙买加",
    "currencySymbol": "J$"
  },
  {
    "code": "JP",
    "name": "Japan",
    "nameZh": "日本",
    "currencySymbol": "¥"
  },
  {
    "code": "JO",
    "name": "Jordan",
    "nameZh": "约旦",
    "currencySymbol": "JD"
  },
  {
    "code": "KZ",
    "name": "Kazakhstan",
    "nameZh": "哈萨克斯坦",
    "currencySymbol": "₸"
  },
  {
    "code": "KE",
    "name": "Kenya",
    "nameZh": "肯尼亚",
    "currencySymbol": "KSh"
  },
  {
    "code": "KI",
    "name": "Kiribati",
    "nameZh": "基里巴斯",
    "currencySymbol": "A$"
  },
  {
    "code": "XK",
    "name": "Kosovo",
    "nameZh": "科索沃",
    "currencySymbol": "€"
  },
  {
    "code": "KW",
    "name": "Kuwait",
    "nameZh": "科威特",
    "currencySymbol": "KD"
  },
  {
    "code": "KG",
    "name": "Kyrgyzstan",
    "nameZh": "吉尔吉斯斯坦",
    "currencySymbol": "с"
  },
  {
    "code": "LA",
    "name": "Laos",
    "nameZh": "老挝",
    "currencySymbol": "₭"
  },
  {
    "code": "LV",
    "name": "Latvia",
    "nameZh": "拉脱维亚",
    "currencySymbol": "€"
  },
  {
    "code": "LB",
    "name": "Lebanon",
    "nameZh": "黎巴嫩",
    "currencySymbol": "L£"
  },
  {
    "code": "LS",
    "name": "Lesotho",
    "nameZh": "莱索托",
    "currencySymbol": "L"
  },
  {
    "code": "LR",
    "name": "Liberia",
    "nameZh": "利比里亚",
    "currencySymbol": "$"
  },
  {
    "code": "LY",
    "name": "Libya",
    "nameZh": "利比亚",
    "currencySymbol": "LD"
  },
  {
    "code": "LI",
    "name": "Liechtenstein",
    "nameZh": "列支敦士登",
    "currencySymbol": "CHF"
  },
  {
    "code": "LT",
    "name": "Lithuania",
    "nameZh": "立陶宛",
    "currencySymbol": "€"
  },
  {
    "code": "LU",
    "name": "Luxembourg",
    "nameZh": "卢森堡",
    "currencySymbol": "€"
  },
  {
    "code": "MO",
    "name": "Macao",
    "nameZh": "中国澳门",
    "currencySymbol": "MOP$"
  },
  {
    "code": "MG",
    "name": "Madagascar",
    "nameZh": "马达加斯加",
    "currencySymbol": "Ar"
  },
  {
    "code": "MW",
    "name": "Malawi",
    "nameZh": "马拉维",
    "currencySymbol": "MK"
  },
  {
    "code": "MY",
    "name": "Malaysia",
    "nameZh": "马来西亚",
    "currencySymbol": "RM"
  },
  {
    "code": "MV",
    "name": "Maldives",
    "nameZh": "马尔代夫",
    "currencySymbol": "Rf"
  },
  {
    "code": "ML",
    "name": "Mali",
    "nameZh": "马里",
    "currencySymbol": "CFA"
  },
  {
    "code": "MT",
    "name": "Malta",
    "nameZh": "马耳他",
    "currencySymbol": "€"
  },
  {
    "code": "MH",
    "name": "Marshall Islands",
    "nameZh": "马绍尔群岛",
    "currencySymbol": "$"
  },
  {
    "code": "MR",
    "name": "Mauritania",
    "nameZh": "毛里塔尼亚",
    "currencySymbol": "UM"
  },
  {
    "code": "MU",
    "name": "Mauritius",
    "nameZh": "毛里求斯",
    "currencySymbol": "Rs"
  },
  {
    "code": "MX",
    "name": "Mexico",
    "nameZh": "墨西哥",
    "currencySymbol": "MX$"
  },
  {
    "code": "FM",
    "name": "Micronesia",
    "nameZh": "密克罗尼西亚",
    "currencySymbol": "$"
  },
  {
    "code": "MD",
    "name": "Moldova",
    "nameZh": "摩尔多瓦",
    "currencySymbol": "L"
  },
  {
    "code": "MC",
    "name": "Monaco",
    "nameZh": "摩纳哥",
    "currencySymbol": "€"
  },
  {
    "code": "MN",
    "name": "Mongolia",
    "nameZh": "蒙古",
    "currencySymbol": "₮"
  },
  {
    "code": "ME",
    "name": "Montenegro",
    "nameZh": "黑山",
    "currencySymbol": "€"
  },
  {
    "code": "MA",
    "name": "Morocco",
    "nameZh": "摩洛哥",
    "currencySymbol": "MAD"
  },
  {
    "code": "MZ",
    "name": "Mozambique",
    "nameZh": "莫桑比克",
    "currencySymbol": "MT"
  },
  {
    "code": "MM",
    "name": "Myanmar",
    "nameZh": "缅甸",
    "currencySymbol": "K"
  },
  {
    "code": "NA",
    "name": "Namibia",
    "nameZh": "纳米比亚",
    "currencySymbol": "N$"
  },
  {
    "code": "NR",
    "name": "Nauru",
    "nameZh": "瑙鲁",
    "currencySymbol": "A$"
  },
  {
    "code": "NP",
    "name": "Nepal",
    "nameZh": "尼泊尔",
    "currencySymbol": "Rs"
  },
  {
    "code": "NL",
    "name": "Netherlands",
    "nameZh": "荷兰",
    "currencySymbol": "€"
  },
  {
    "code": "NZ",
    "name": "New Zealand",
    "nameZh": "新西兰",
    "currencySymbol": "NZ$"
  },
  {
    "code": "NI",
    "name": "Nicaragua",
    "nameZh": "尼加拉瓜",
    "currencySymbol": "C$"
  },
  {
    "code": "NE",
    "name": "Niger",
    "nameZh": "尼日尔",
    "currencySymbol": "CFA"
  },
  {
    "code": "NG",
    "name": "Nigeria",
    "nameZh": "尼日利亚",
    "currencySymbol": "₦"
  },
  {
    "code": "KP",
    "name": "North Korea",
    "nameZh": "朝鲜",
    "currencySymbol": "₩"
  },
  {
    "code": "MK",
    "name": "North Macedonia",
    "nameZh": "北马其顿",
    "currencySymbol": "ден"
  },
  {
    "code": "NO",
    "name": "Norway",
    "nameZh": "挪威",
    "currencySymbol": "kr"
  },
  {
    "code": "OM",
    "name": "Oman",
    "nameZh": "阿曼",
    "currencySymbol": "OMR"
  },
  {
    "code": "PK",
    "name": "Pakistan",
    "nameZh": "巴基斯坦",
    "currencySymbol": "Rs"
  },
  {
    "code": "PW",
    "name": "Palau",
    "nameZh": "帕劳",
    "currencySymbol": "$"
  },
  {
    "code": "PS",
    "name": "Palestine",
    "nameZh": "巴勒斯坦",
    "currencySymbol": "₪"
  },
  {
    "code": "PA",
    "name": "Panama",
    "nameZh": "巴拿马",
    "currencySymbol": "B/."
  },
  {
    "code": "PG",
    "name": "Papua New Guinea",
    "nameZh": "巴布亚新几内亚",
    "currencySymbol": "K"
  },
  {
    "code": "PY",
    "name": "Paraguay",
    "nameZh": "巴拉圭",
    "currencySymbol": "Gs"
  },
  {
    "code": "PE",
    "name": "Peru",
    "nameZh": "秘鲁",
    "currencySymbol": "S/"
  },
  {
    "code": "PH",
    "name": "Philippines",
    "nameZh": "菲律宾",
    "currencySymbol": "₱"
  },
  {
    "code": "PL",
    "name": "Poland",
    "nameZh": "波兰",
    "currencySymbol": "zł"
  },
  {
    "code": "PT",
    "name": "Portugal",
    "nameZh": "葡萄牙",
    "currencySymbol": "€"
  },
  {
    "code": "PR",
    "name": "Puerto Rico",
    "nameZh": "波多黎各",
    "currencySymbol": "$"
  },
  {
    "code": "QA",
    "name": "Qatar",
    "nameZh": "卡塔尔",
    "currencySymbol": "QR"
  },
  {
    "code": "RO",
    "name": "Romania",
    "nameZh": "罗马尼亚",
    "currencySymbol": "lei"
  },
  {
    "code": "RU",
    "name": "Russia",
    "nameZh": "俄罗斯",
    "currencySymbol": "₽"
  },
  {
    "code": "RW",
    "name": "Rwanda",
    "nameZh": "卢旺达",
    "currencySymbol": "FRw"
  },
  {
    "code": "KN",
    "name": "Saint Kitts and Nevis",
    "nameZh": "圣基茨和尼维斯",
    "currencySymbol": "$"
  },
  {
    "code": "LC",
    "name": "Saint Lucia",
    "nameZh": "圣卢西亚",
    "currencySymbol": "$"
  },
  {
    "code": "VC",
    "name": "Saint Vincent and the Grenadines",
    "nameZh": "圣文森特和格林纳丁斯",
    "currencySymbol": "$"
  },
  {
    "code": "WS",
    "name": "Samoa",
    "nameZh": "萨摩亚",
    "currencySymbol": "T"
  },
  {
    "code": "SM",
    "name": "San Marino",
    "nameZh": "圣马力诺",
    "currencySymbol": "€"
  },
  {
    "code": "ST",
    "name": "Sao Tome and Principe",
    "nameZh": "圣多美和普林西比",
    "currencySymbol": "Db"
  },
  {
    "code": "SA",
    "name": "Saudi Arabia",
    "nameZh": "沙特阿拉伯",
    "currencySymbol": "﷼"
  },
  {
    "code": "SN",
    "name": "Senegal",
    "nameZh": "塞内加尔",
    "currencySymbol": "CFA"
  },
  {
    "code": "RS",
    "name": "Serbia",
    "nameZh": "塞尔维亚",
    "currencySymbol": "дин"
  },
  {
    "code": "SC",
    "name": "Seychelles",
    "nameZh": "塞舌尔",
    "currencySymbol": "Rs"
  },
  {
    "code": "SL",
    "name": "Sierra Leone",
    "nameZh": "塞拉利昂",
    "currencySymbol": "Le"
  },
  {
    "code": "SG",
    "name": "Singapore",
    "nameZh": "新加坡",
    "currencySymbol": "S$"
  },
  {
    "code": "SK",
    "name": "Slovakia",
    "nameZh": "斯洛伐克",
    "currencySymbol": "€"
  },
  {
    "code": "SI",
    "name": "Slovenia",
    "nameZh": "斯洛文尼亚",
    "currencySymbol": "€"
  },
  {
    "code": "SB",
    "name": "Solomon Islands",
    "nameZh": "所罗门群岛",
    "currencySymbol": "$"
  },
  {
    "code": "SO",
    "name": "Somalia",
    "nameZh": "索马里",
    "currencySymbol": "Sh"
  },
  {
    "code": "ZA",
    "name": "South Africa",
    "nameZh": "南非",
    "currencySymbol": "R"
  },
  {
    "code": "KR",
    "name": "South Korea",
    "nameZh": "韩国",
    "currencySymbol": "₩"
  },
  {
    "code": "SS",
    "name": "South Sudan",
    "nameZh": "南苏丹",
    "currencySymbol": "£"
  },
  {
    "code": "ES",
    "name": "Spain",
    "nameZh": "西班牙",
    "currencySymbol": "€"
  },
  {
    "code": "LK",
    "name": "Sri Lanka",
    "nameZh": "斯里兰卡",
    "currencySymbol": "Rs"
  },
  {
    "code": "SD",
    "name": "Sudan",
    "nameZh": "苏丹",
    "currencySymbol": "ج.س"
  },
  {
    "code": "SR",
    "name": "Suriname",
    "nameZh": "苏里南",
    "currencySymbol": "$"
  },
  {
    "code": "SE",
    "name": "Sweden",
    "nameZh": "瑞典",
    "currencySymbol": "kr"
  },
  {
    "code": "CH",
    "name": "Switzerland",
    "nameZh": "瑞士",
    "currencySymbol": "CHF"
  },
  {
    "code": "SY",
    "name": "Syria",
    "nameZh": "叙利亚",
    "currencySymbol": "£"
  },
  {
    "code": "TW",
    "name": "Taiwan",
    "nameZh": "中国台湾",
    "currencySymbol": "NT$"
  },
  {
    "code": "TJ",
    "name": "Tajikistan",
    "nameZh": "塔吉克斯坦",
    "currencySymbol": "ЅМ"
  },
  {
    "code": "TZ",
    "name": "Tanzania",
    "nameZh": "坦桑尼亚",
    "currencySymbol": "TSh"
  },
  {
    "code": "TH",
    "name": "Thailand",
    "nameZh": "泰国",
    "currencySymbol": "฿"
  },
  {
    "code": "TL",
    "name": "Timor-Leste",
    "nameZh": "东帝汶",
    "currencySymbol": "$"
  },
  {
    "code": "TG",
    "name": "Togo",
    "nameZh": "多哥",
    "currencySymbol": "CFA"
  },
  {
    "code": "TO",
    "name": "Tonga",
    "nameZh": "汤加",
    "currencySymbol": "T$"
  },
  {
    "code": "TT",
    "name": "Trinidad and Tobago",
    "nameZh": "特立尼达和多巴哥",
    "currencySymbol": "TT$"
  },
  {
    "code": "TN",
    "name": "Tunisia",
    "nameZh": "突尼斯",
    "currencySymbol": "DT"
  },
  {
    "code": "TR",
    "name": "Turkey",
    "nameZh": "土耳其",
    "currencySymbol": "₺"
  },
  {
    "code": "TM",
    "name": "Turkmenistan",
    "nameZh": "土库曼斯坦",
    "currencySymbol": "m"
  },
  {
    "code": "TV",
    "name": "Tuvalu",
    "nameZh": "图瓦卢",
    "currencySymbol": "A$"
  },
  {
    "code": "UG",
    "name": "Uganda",
    "nameZh": "乌干达",
    "currencySymbol": "USh"
  },
  {
    "code": "UA",
    "name": "Ukraine",
    "nameZh": "乌克兰",
    "currencySymbol": "₴"
  },
  {
    "code": "AE",
    "name": "United Arab Emirates",
    "nameZh": "阿联酋",
    "currencySymbol": "د.إ"
  },
  {
    "code": "UK",
    "name": "United Kingdom",
    "nameZh": "英国",
    "currencySymbol": "£"
  },
  {
    "code": "US",
    "name": "United States",
    "nameZh": "美国",
    "currencySymbol": "$"
  },
  {
    "code": "UY",
    "name": "Uruguay",
    "nameZh": "乌拉圭",
    "currencySymbol": "$"
  },
  {
    "code": "UZ",
    "name": "Uzbekistan",
    "nameZh": "乌兹别克斯坦",
    "currencySymbol": "soʻm"
  },
  {
    "code": "VU",
    "name": "Vanuatu",
    "nameZh": "瓦努阿图",
    "currencySymbol": "VT"
  },
  {
    "code": "VA",
    "name": "Vatican City",
    "nameZh": "梵蒂冈",
    "currencySymbol": "€"
  },
  {
    "code": "VE",
    "name": "Venezuela",
    "nameZh": "委内瑞拉",
    "currencySymbol": "Bs"
  },
  {
    "code": "VN",
    "name": "Vietnam",
    "nameZh": "越南",
    "currencySymbol": "₫"
  },
  {
    "code": "YE",
    "name": "Yemen",
    "nameZh": "也门",
    "currencySymbol": "﷼"
  },
  {
    "code": "ZM",
    "name": "Zambia",
    "nameZh": "赞比亚",
    "currencySymbol": "ZK"
  },
  {
    "code": "ZW",
    "name": "Zimbabwe",
    "nameZh": "津巴布韦",
    "currencySymbol": "$"
  }
]

export function filterWorldCountries (keyword) {
  const q = (keyword || '').trim().toLowerCase()
  if (!q) return WORLD_COUNTRIES
  const raw = (keyword || '').trim()
  return WORLD_COUNTRIES.filter(c => (
    c.code.toLowerCase().includes(q)
    || c.name.toLowerCase().includes(q)
    || (c.nameZh && c.nameZh.includes(raw))
  ))
}

export function findWorldCountry (code) {
  if (!code) return null
  const upper = String(code).toUpperCase()
  return WORLD_COUNTRIES.find(c => c.code === upper) || null
}
